export const addTextToFeatureTable = (textLine, criteriaName, unlockedValue, playerValue, featureTextArr, 
    featureCriteriaArr, eligible, greaterThan) => {
    if (!greaterThan){
            greaterThan = false;
    }
    let textColor = "black";
    if (greaterThan === false){
        if (+unlockedValue <= +playerValue){
            textColor = "green";
        }else{
            eligible = false;
        }
    }else{
        if (+unlockedValue > +playerValue){
            textColor = "green";
        }else{
            eligible = false;
        }
    }
    const textFeatureObj = {textLine: textLine, textColor: textColor};
    featureTextArr.push(textFeatureObj);
    const featureCriteriaObj = {criteriaName: criteriaName, criteriaValue: unlockedValue,
        playerValue: playerValue, textColor: textColor};
    featureCriteriaArr.push(featureCriteriaObj);
    return eligible;
}
export default addTextToFeatureTable;